import { render, staticRenderFns } from "./HospitalIcon.vue?vue&type=template&id=74ec217c"
import script from "./HospitalIcon.vue?vue&type=script&lang=js"
export * from "./HospitalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports